import React from "react";
import { Button } from "reactstrap";
import {
  FaCheckCircle,
  FaExclamationTriangle,
  FaUserCheck,
  FaClock,
} from "react-icons/fa";

const RegistrationResult = ({ status, message, onTryAgain, onRequestNewCode }) => {
  const isMobile = window.innerWidth < 768;

  const getIcon = () => {
    const size = isMobile ? "2.5em" : "3em";
    switch (status) {
      case "success":
        return <FaCheckCircle size={size} color="#28a745" />;
      case "already_registered":
        return <FaUserCheck size={size} color="#007bff" />;
      case "expired":
        return <FaClock size={size} color="#ffc107" />;
      case "invalid_code":
      case "error":
      default:
        return <FaExclamationTriangle size={size} color="#dc3545" />;
    }
  };

  const getTitle = () => {
    switch (status) {
      case "success":
        return "Done!";
      case "already_registered":
        return "Already Registered";
      case "expired":
        return "Code Expired";
      case "invalid_code":
        return "Invalid Code";
      default:
        return "Error";
    }
  };

  const showTryAgain = status === "error";
  const showRequestNewCode = status === "expired";
  const showTryAgainForInvalidCode = status === "invalid_code";

  return (
    <div
      style={{
        textAlign: "center",
        padding: isMobile ? "30px 10px" : "40px 20px",
      }}
    >
      {getIcon()}
      <h3
        style={{
          marginTop: isMobile ? "20px" : "30px",
          color: "#333",
          fontSize: isMobile ? "22px" : "28px",
        }}
      >
        {getTitle()}
      </h3>
      <p
        style={{
          color: "#666",
          marginBottom: isMobile ? "20px" : "30px",
          fontSize: isMobile ? "14px" : "16px",
          whiteSpace: "pre-line",
          lineHeight: 1.5,
        }}
      >
        {message}
      </p>
      {showTryAgain && (
        <Button
          color="primary"
          onClick={onTryAgain}
          size={isMobile ? "sm" : "md"}
        >
          Try Again
        </Button>
      )}
      {showRequestNewCode && (
        <Button
          color="primary"
          onClick={onRequestNewCode || onTryAgain}
          size={isMobile ? "sm" : "md"}
        >
          Request New Code
        </Button>
      )}
      {showTryAgainForInvalidCode && (
        <Button
          color="primary"
          onClick={onTryAgain}
          size={isMobile ? "sm" : "md"}
        >
          Try Again
        </Button>
      )}
    </div>
  );
};

export default RegistrationResult;
